import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'

export const TeamApi = createApi({
  reducerPath: 'TeamApi',
  tagTypes: ['Teams'],
  baseQuery: fetchBaseQuery({
    // Fill in your own server starting URL here
    baseUrl: myConstants.baseURL,
    prepareHeaders: (headers, { getState }) => 
    {        
      const token = getState().auth.token;
      // console.log("prepare-header:" + token);
      if (token) 
      {
        headers.set('Authorization', `token ${token}`);
      }
      return headers;      
    },    
  }),
  endpoints: (build) => ({
    fetchTeams: 
      build.query(
        {
          query: (clubDescriptor) => ({
            url: myConstants.endpoints.api.base 
                + clubDescriptor.year 
                + (clubDescriptor.clubLabel !== ''?'/' + clubDescriptor.clubLabel:'') 
                + myConstants.endpoints.api.teams,
            method: 'GET',
          }),
      
          providesTags: (result, error, clubDescriptor) => 
          [
            { 
              type : 'Teams', 
              id: `${clubDescriptor.year}_${clubDescriptor.clubLabel}` 
            } 
          ],          
        }
      ),
    
    addTeam:
      build.mutation({
        query: (teamData) => ({
          url: myConstants.endpoints.api.base
              + teamData.year 
              + '/'
              + teamData.clubLabel
              + '/'
              + teamData.label
              + '/'
              + myConstants.endpoints.actions.team.add,
          method: 'POST',
          body: teamData,  
        }),
        invalidatesTags: (result, error, teamData) => 
        [
          { 
            type: 'Teams', 
            id: `${teamData.year}_${teamData.clubLabel}` 
          },
          { 
            type: 'Teams', 
            id: `${teamData.year}_` 
          },
        ],
      }),

    updateTeamPayment: 
      build.mutation({
        query: ({ year, clubLabel, teamLabel, teamCounter, feePayedDate, feePayedSum}) => 
          (
            {
              url: myConstants.endpoints.api.base
                  + year
                  + '/'
                  + clubLabel
                  + '/'
                  + teamLabel
                  + '/'
                  + teamCounter
                  + '/'
                  + myConstants.endpoints.actions.team.pay,
              method: 'PATCH',
              body: { feePayedDate, feePayedSum },
            }
          ),
          invalidatesTags: (result, error, data) => 
          [
            {
              type: 'Teams', 
              id: `${data.year}_`,
            },
            {
              type: 'Teams', 
              id: `${data.year}_${data.clubLabel}`,
            }
          ],
      }),

    updateTeam: 
      build.mutation({
        query: ({ year, clubLabel, teamLabel, teamCounter, ...teamData }) => 
          (
            {
              url: myConstants.endpoints.api.base
                  + year
                  + '/'
                  + clubLabel
                  + '/'
                  + teamLabel
                  + '/'
                  + teamCounter
                  + '/'
                  + myConstants.endpoints.actions.team.update,
              method: 'PATCH',
              body: teamData,
            }
          ),
          invalidatesTags: (result, error, data) => 
          [
            {
              type: 'Teams', 
              id: `${data.year}_`,
            },
            {
              type: 'Teams', 
              id: `${data.year}_${data.clubLabel}`,
            }
          ],
      }),

      
    deleteTeam: 
      build.mutation({
        query: ({ year, clubLabel, teamLabel, teamCounter }) => 
          (
            {
              url: myConstants.endpoints.api.base
                  + year
                  + '/'
                  + clubLabel
                  + '/'
                  + teamLabel
                  + '/'
                  + teamCounter
                  + '/'
                  + myConstants.endpoints.actions.team.remove,
              method: 'DELETE',
            }
          ),
          invalidatesTags: (result, error, data) => 
          [
            {
              type: 'Teams', 
              id: `${data.year}_`,
            },
            {
              type: 'Teams', 
              id: `${data.year}_${data.clubLabel}`,
            }
          ],
      }),  
      
    updateTeamStatus: 
      build.mutation({
        query: ({ year, clubLabel, teamLabel, teamCounter, status }) => 
          (
            {
              url: myConstants.endpoints.api.base
                  + year
                  + '/'
                  + clubLabel
                  + '/'
                  + teamLabel
                  + '/'
                  + teamCounter
                  + '/'
                  + myConstants.endpoints.actions.team.status,
              method: 'PATCH',
              body: {status},
            }
          ),
          invalidatesTags: (result, error, data) => 
          [
            {
              type: 'Teams', 
              id: `${data.year}_`,
            },
            {
              type: 'Teams', 
              id: `${data.year}_${data.clubLabel}`,
            }
          ],
      }),

  }),
})

export const { 
  useFetchTeamsQuery, 
  useLazyFetchTeamsQuery, 
  usePrefetch,
  useAddTeamMutation,
  useUpdateTeamPaymentMutation,
  useUpdateTeamMutation, 
  useDeleteTeamMutation,
  useUpdateTeamStatusMutation,
} = TeamApi